import { useEffect, useState } from 'react';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { GrowthbookWrapper, useSession } from '@ltvco/refresh-lib/v1';
import { ThemeWrapper } from './ThemeWrapper';

export function Growthbook({ children }: { children: JSX.Element }) {
  const isTestingEnv = import.meta.env.VITE_IS_TEST;
  const {
    session: { account },
  } = useSession();
  const { isMobile } = useScreenSize();
  const deviceType = isMobile ? 'web-mobile' : 'desktop';

  const [customAttributes, setCustomAttributes] = useState<
    Record<string, unknown>
  >({});
  const [isGbReady, setIsGbReady] = useState(isTestingEnv || false);

  useEffect(() => {
    if (!account) return;
    setCustomAttributes({
      'device-type': deviceType,
    });
  }, [account]);

  if (isTestingEnv) {
    return <ThemeWrapper isGbReady={isGbReady}>{children}</ThemeWrapper>;
  }
  return (
    <GrowthbookWrapper
      enableDevMode={true}
      apiHost={'https://gbbv.beenverified.com'}
      clientKey={'sdk-sH9Cly3zfuFM9mdc'}
      decryptionKey={'nZwGIW+xki4yOM6qBBx8Kg=='}
      subscribeToChanges={false}
      customAttributes={customAttributes}
      setIsGbReady={setIsGbReady}
      brandName={'bumper'}
    >
      <ThemeWrapper isGbReady={isGbReady}>{children}</ThemeWrapper>
    </GrowthbookWrapper>
  );
}
